/**
 * The signal of every write (any non-GET) the server accepted, with its endpoint. The API client
 * emits it (api.service `makeRequest`); the query client marks every cached read stale on it
 * (platform/query-client.ts): a write may change anything a screen derives from the ledger, and a
 * hand-kept list of keys per mutation drifts (a delete-all once left the balances screen showing
 * the deleted data for minutes). Its own module: neither side, nor a test mocking one, owns it.
 */
const listeners = new Set<(endpoint: string) => void>()

/** Subscribes `listener`; returns the unsubscribe. */
export function onAcceptedWrite(listener: (endpoint: string) => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** Tells every listener the server accepted a write to `endpoint`. */
export function emitAcceptedWrite(endpoint: string): void {
  listeners.forEach((listener) => listener(endpoint))
}
